import { useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { useRevenueData } from "@/hooks/budget/useRevenueData";
import { ExpenseTypeField } from "./expense/ExpenseTypeField";
import { ExpenseBasicFields } from "./expense/ExpenseBasicFields";
import { useExpenseSubmission } from "./expense/useExpenseSubmission";

interface ExpenseFormData {
  name: string;
  amount: number;
  notes: string;
  expenseType: "deducted" | "external";
  expenseCategory: string;
  expenseSubcategory: string;
}

interface AddExpenseFormProps {
  onSuccess?: () => void;
}

export const AddExpenseForm = ({ onSuccess }: AddExpenseFormProps) => {
  const { validatedAmount } = useRevenueData();
  const { isLoading, submitExpense } = useExpenseSubmission(onSuccess);

  const form = useForm<ExpenseFormData>({
    defaultValues: {
      name: "",
      amount: 0,
      notes: "",
      expenseType: "deducted",
      expenseCategory: "",
      expenseSubcategory: "",
    },
  });

  const onSubmit = async (data: ExpenseFormData) => {
    await submitExpense(data, validatedAmount);
  };

  const currentExpenseType = form.watch("expenseType");

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <ExpenseBasicFields form={form} />
        <ExpenseTypeField 
          form={form}
          currentExpenseType={currentExpenseType}
          validatedAmount={validatedAmount}
        />
        <Button type="submit" disabled={isLoading} className="w-full">
          {isLoading ? "Ajout en cours..." : "Ajouter la dépense"}
        </Button>
      </form>
    </Form>
  );
};